import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const searchAttributes = [
  // Node.
  'page_title',
  'body',
  'body_summarized',
  'image_alt',
  'paragraphs_body',
  'paragraphs_entity_name',
  'paragraphs_entity_title',
  'article_type_searchable',
  'projects_searchable',
  'themes_searchable',
  'departments_searchable',
  'equipment_types_searchable',
  'vacancy_function_name',
  'locations_name',
  'labels_searchable',

  // Taxonomy term.
  'taxonomy_name',
  'taxonomy_description',
  'taxonomy_image_alt',

  // Profile.
  'first_name_searchable',
  'last_name_searchable',
  'profile_description',
  'profile_image_alt',
  'project_research_leader_name',
  'profile_departments_searchable',
  'profile_functions_name',
  'profile_locations_name',
  'profile_themes_searchable',
];

export const resultAttributes = [
  // General.
  'url',
  'entity_type',

  // Node.
  'content_type',
  'page_title',
  'body',
  'body_summarized',
  'paragraphs_body_processed',
  'link_url',
  'article_type_name',
  'image_ratio_1_1_xxs',
  'image_ratio_1_1_xs',
  'image_ratio_1_1_sm',
  'image_ratio_1_1_md',
  'image_ratio_3_2_xxs',
  'image_ratio_3_2_xs',
  'image_ratio_3_2_sm',
  'image_ratio_3_2_md',
  'image_ratio_3_4_xxs',
  'image_ratio_3_4_xs',
  'image_ratio_3_4_sm',
  'image_ratio_3_4_md',
  'image_ratio_4_3_xxs',
  'image_ratio_4_3_xs',
  'image_ratio_4_3_sm',
  'image_ratio_4_3_md',
  'image_ratio_16_9_xxs',
  'image_ratio_16_9_xs',
  'image_ratio_16_9_sm',
  'image_ratio_16_9_md',
  'image_alt',

  // Taxonomy term.
  'vid',
  'taxonomy_name',
  'taxonomy_description',
  'taxonomy_teaser_image_ratio_1_1_xxs',
  'taxonomy_teaser_image_ratio_1_1_xs',
  'taxonomy_teaser_image_ratio_1_1_sm',
  'taxonomy_teaser_image_ratio_1_1_md',
  'taxonomy_teaser_image_ratio_1_1_lg',
  'taxonomy_image_alt',

  // Profile.
  'profile_type',
  'first_name',
  'last_name',
  'profile_description_processed',
  'profile_image_ratio_1_1_xxs',
  'profile_image_ratio_1_1_xs',
  'profile_image_ratio_1_1_sm',
  'profile_image_ratio_1_1_md',
  'profile_image_alt',
];

export const facetAttributes: Exclude<SearchkitWrapperProps['searchSettings']['facet_attributes'], undefined> = [
  {
    attribute: 'content_type',
    field: 'aggregated_content_type',
    type: 'string',
    facetQuery: (field, size) => ({
      terms: {
        field,
        size,
        exclude: ['basic_page', 'landing_page'],
      },
    }),
  },
  {
    attribute: 'article_type_name',
    field: 'article_type_name',
    type: 'string',
  },
  {
    attribute: 'themes_name',
    field: 'themes_name',
    type: 'string',
  },
  {
    attribute: 'departments_name',
    field: 'aggregated_departments_name',
    type: 'string',
  },
  {
    attribute: 'locations_name',
    field: 'aggregated_locations_name',
    type: 'string',
  },
];

export const sorting: Exclude<SearchkitWrapperProps['searchSettings']['sorting'], undefined> = {
  default: [
    // Default sorting by score.
    {
      field: '_score',
      order: 'desc',
    },
    // Articles and vacancies.
    {
      field: 'publish_date',
      order: 'desc',
    },
    // Projects.
    {
      field: 'project_duration_start_date',
      order: 'desc',
    },
    // Other nodes.
    {
      field: 'created',
      order: 'desc',
    },
    // Profiles.
    {
      field: 'last_name',
      order: 'asc',
    },
    // Taxonomy terms.
    {
      field: 'taxonomy_weight',
      order: 'asc',
    },
  ],
};
